import MaterialIcon from '@material/react-material-icon';

const SidebarData = [
  { caption: 'Home' },
  {
    title: "Inicio",
    href: "/app/starter",
    icon: <MaterialIcon icon="speed" />,
    id: 1,
    suffix: "New",
    suffixColor: "bg-success",
    collapisble: false,
  },

  { caption: 'UI' },
  {
    title: 'UI Elements',
    href: '/app/ui',
    id: 3,
    suffix: '22',
    suffixColor: 'bg-danger',
    icon: <MaterialIcon icon="grid_view" />,
    collapisble: true,
    children: [
      {
        title: "Alert",
        href: "/app/ui/alerts",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Buttons",
        href: "/app/buttons",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Cards",
        href: "/app/cards",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Grid",
        href: "/app/grid",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Badges",
        href: "/app/badges",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Table",
        href: "/app/table",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Forms",
        href: "/app/forms",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "Breadcrumbs",
        href: "/app/breadcrumbs",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: "About",
        href: "/app/about",
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
    ],
  },
  {
    title: 'DD Menu',
    href: '/',
    id: 7,
    collapisble: true,
    icon: <MaterialIcon icon="radio_button_checked" />,
    children: [
      {
        title: 'Simple dd 1',
        href: '/',
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: 'Simple dd 2',
        href: '/',
        icon: <MaterialIcon icon="radio_button_checked" />,
      },
      {
        title: 'Simple dd 3',
        href: '/',
        icon: <MaterialIcon icon="radio_button_checked" />,
        children: [
          {
            title: 'Simple dd 1.1',
            href: '/alerts',
            icon: <MaterialIcon icon="radio_button_checked" />,
          },
        ],
      },
    ],
  },
];

export default SidebarData;
